// Müşteri menüsü arayüz metinleri (sabit/chrome). Menü İÇERİĞİ (ürün/kategori adları)
// backend Translation tablosundan gelir; burası yalnızca buton/etiket gibi statik metinler içindir.
// Tanımlı olmayan diller İngilizceye (DEFAULT_UI_LANG) düşer.

export const DEFAULT_UI_LANG = 'en';

export const uiStrings = {
  tr: {
    loading: 'Menü yükleniyor...',
    back: 'Geri',
    vegetarian: 'Vejetaryen',
    spicy: 'Acılı',
    ingredients: 'Alerjenler',
    calories: 'Kalori',
    caloriesUnit: 'kcal',
    prepTime: 'Hazırlık Süresi',
    minutesShort: 'dk',
    searchPlaceholder: 'Ürün ara...',
    all: 'Tümü',
    noProducts: 'Ürün bulunamadı',
    noProductsHint: 'Farklı bir kategori veya arama terimi deneyin',
    cart: 'Sepetim',
    cartEmpty: 'Sepetiniz boş',
    total: 'Toplam:',
    placeOrder: 'Sipariş Ver',
    selectLanguage: 'Dil seçin',
  },
  en: {
    loading: 'Loading menu...',
    back: 'Back',
    vegetarian: 'Vegetarian',
    spicy: 'Spicy',
    ingredients: 'Allergens',
    calories: 'Calories',
    caloriesUnit: 'kcal',
    prepTime: 'Preparation Time',
    minutesShort: 'min',
    searchPlaceholder: 'Search products...',
    all: 'All',
    noProducts: 'No products found',
    noProductsHint: 'Try a different category or search term',
    cart: 'My Cart',
    cartEmpty: 'Your cart is empty',
    total: 'Total:',
    placeOrder: 'Place Order',
    selectLanguage: 'Select language',
  },
  de: {
    loading: 'Menü wird geladen...',
    back: 'Zurück',
    vegetarian: 'Vegetarisch',
    spicy: 'Scharf',
    ingredients: 'Allergene',
    calories: 'Kalorien',
    caloriesUnit: 'kcal',
    prepTime: 'Zubereitungszeit',
    minutesShort: 'Min',
    searchPlaceholder: 'Produkte suchen...',
    all: 'Alle',
    noProducts: 'Keine Produkte gefunden',
    noProductsHint: 'Versuchen Sie eine andere Kategorie oder einen anderen Suchbegriff',
    cart: 'Mein Warenkorb',
    cartEmpty: 'Ihr Warenkorb ist leer',
    total: 'Gesamt:',
    placeOrder: 'Bestellen',
    selectLanguage: 'Sprache wählen',
  },
};

// key'i seçilen dile göre döndürür; yoksa İngilizceye, o da yoksa key'in kendisine düşer.
export const translate = (lang, key) => {
  const table = uiStrings[lang] || uiStrings[DEFAULT_UI_LANG];
  return table[key] || uiStrings[DEFAULT_UI_LANG][key] || key;
};
